export default __webpack_public_path__ + "static/media/07.213a18bf.jpg";